const Structure = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "structure": "Structure",

    // ERROR
    "error_name": "Enter Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": 'DESCRIPTION',
    "table_status": "STATUS",

}

export default Structure;